export async function buyoutYBIUseCase(client_id, period, year, month, shipping_service, yegoDashboardRepository) {
    const result = await yegoDashboardRepository.buyoutYBI(client_id, period, year, month, shipping_service);

    const info = await new yegoDashboardRepository.buyout_model(result.data);

    if (!info.isValid()) {
        throw new Error("Buyout Answer Inválido");
    }

    return result.data;
}